import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { Checkbox } from "@atlaskit/checkbox";

import { PRIMARY_BLACK } from "../constants";

const wrapperStyles = css({
    "padding": "19px 16px",
    "border": "2px #DCDFE4 solid !important",
    "borderRadius": "8px",
    "minWidth": "400px",
    "cursor": "pointer",
    "display": "flex",
    "alignItems": "center",
    "&:hover": {
        borderColor: "#0C66E4 !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label": {
        alignItems: "center",
        cursor: "pointer",
        textAlign: "left"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "label span": {
        margin: "0 auto 0 4px",
        cursor: "pointer"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "input": {
        cursor: "pointer"
    }
});

const labelStyles = css({
    fontFamily: "var(--bxp-charlie-display-font-family)",
    fontWeight: 600,
    color: `${PRIMARY_BLACK}`,
    fontSize: "1rem",
    lineHeight: "1.2rem",
    textAlign: "left"
});

const JtbdCheckbox = ({
    name,
    id,
    isChecked,
    handleClick,
    isDisabled
}: {
    name: string;
    id: string;
    isChecked: boolean;
    handleClick: () => void;
    isDisabled: boolean;
}) => {
    const intl = useIntl();
    return (
        // Tech debt that should be fixed. See ldr/0012-jsx-a11y-strict.md for details.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            css={[
                wrapperStyles,
                isChecked === true && css({ borderColor: "#0C66E4 !important" })
            ]}
            onClick={(e) => {
                e.preventDefault();
                handleClick();
            }}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    handleClick();
                }
            }}
        >
            <Checkbox
                value={name}
                id={id}
                name={name}
                label={
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <label
                        htmlFor={id}
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => e.stopPropagation()}
                        css={labelStyles}
                    >
                        {intl.formatMessage({
                            id: id,
                            defaultMessage: name
                        })}
                    </label>
                }
                isChecked={isChecked}
                isDisabled={isDisabled}
                onClick={(e) => {
                    e.stopPropagation();
                    handleClick();
                }}
            />
        </div>
    );
};

export default JtbdCheckbox;
